/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Settings_Collaborators_Manageroles_Rolescount2Inputs */

const en_settings_collaborators_manageroles_rolescount2 = /** @type {(inputs: Settings_Collaborators_Manageroles_Rolescount2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} roles`)
};

/**
* | output |
* | --- |
* | "{count} roles" |
*
* @param {Settings_Collaborators_Manageroles_Rolescount2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_collaborators_manageroles_rolescount2 = /** @type {((inputs: Settings_Collaborators_Manageroles_Rolescount2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Collaborators_Manageroles_Rolescount2Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_collaborators_manageroles_rolescount2(inputs)
});
export { settings_collaborators_manageroles_rolescount2 as "settings_collaborators_manageRoles_rolesCount" }